import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_COIN_REQUEST = 'coin/FETCH_COIN_REQUEST'
const FETCH_COIN_SUCCESS = 'coin/FETCH_COIN_SUCCESS'
const FETCH_COIN_FAILURE = 'coin/FETCH_COIN_FAILURE'

const FETCH_TRANSACTION_REQUEST = 'coin/FETCH_TRANSACTION_REQUEST'
const FETCH_TRANSACTION_SUCCESS = 'coin/FETCH_TRANSACTION_SUCCESS'
const FETCH_TRANSACTION_FAILURE = 'coin/FETCH_TRANSACTION_FAILURE'

const UPDATE_COIN_REQUEST = 'coin/UPDATE_COIN_REQUEST'
const UPDATE_COIN_SUCCESS = 'coin/UPDATE_COIN_SUCCESS'
const UPDATE_COIN_FAILURE = 'coin/UPDATE_COIN_FAILURE'

const UPDATE_COIN_ALL_REQUEST = 'coin/UPDATE_COIN_ALL_REQUEST'
const UPDATE_COIN_ALL_SUCCESS = 'coin/UPDATE_COIN_ALL_SUCCESS'
const UPDATE_COIN_ALL_FAILURE = 'coin/UPDATE_COIN_ALL_FAILURE'



// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  coin: [],
  transaction: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COIN_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_COIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coin: action.payload
      }
    case FETCH_COIN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transaction: action.payload
      }
    case FETCH_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case UPDATE_COIN_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case UPDATE_COIN_SUCCESS:
        return {
          ...state,
          isLoading: false
        }
      case UPDATE_COIN_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
        case UPDATE_COIN_ALL_REQUEST:
          return {
            ...state,
            isLoading: true
          }
        case UPDATE_COIN_ALL_SUCCESS:
          return {
            ...state,
            isLoading: false
          }
        case UPDATE_COIN_ALL_FAILURE:
          return {
            ...state,
            error: action.error,
            isLoading: false
          }
    default:
      return state
  }
}

// Action Creators
export const fetchCoinByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_COIN_REQUEST
      })
      const response = await API.get(EndPoints.HEROPROMOTE + `/getCoin` + `/${id}`)
      dispatch({
        type: FETCH_COIN_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_COIN_FAILURE
      })
    }
  }
}

export const fetchTransectionByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_TRANSACTION_REQUEST
      })
      const response = await API.get(EndPoints.HEROPROMOTE + `/getTransaction` + `/${id}`)
      dispatch({
        type: FETCH_TRANSACTION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_TRANSACTION_FAILURE
      })
    }
  }
}

export const updateCoin = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''

      const heroId =  data.heroId
      const amount =  data.amount
      const transactionFlag =  data.transactionFlag
      const username = localStorage.getItem('username')

      await API.post(EndPoints.HEROPROMOTE + `/makeTransaction`, null , {
        headers: {
          Authorization: authorizationHeader
        },
        params: {
          heroId: heroId,
          amount : amount ,
          transactionFlag : transactionFlag,
          transactionPerson : username
        }
      })
      dispatch({
        type: UPDATE_COIN_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_FAILURE
      })
    }
  }
}
export const updateCoinAllHero = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_COIN_ALL_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''

      const amount =  data.amount
      const transactionFlag =  data.transactionFlag
      const username = localStorage.getItem('username')

      await API.post(EndPoints.HEROPROMOTE + `/makeTransactionAllHero`, null , {
        headers: {
          Authorization: authorizationHeader
        },
        params: {
          amount : amount ,
          transactionFlag : transactionFlag,
          transactionPerson : username
        }
      })
      dispatch({
        type: UPDATE_COIN_ALL_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_COIN_ALL_FAILURE
      })
    }
  }
}





// WEBPACK FOOTER //
// ./src/modules/coin.js